import {
  AfterViewInit,
  ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, Renderer2,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'mcrai-icon',
  template: `<ng-content></ng-content>
`,
  styles: [`.mcrai-icon{font-family:icomoon!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;font-size:24px;letter-spacing:0;-webkit-font-feature-settings:"liga";font-feature-settings:"liga";-webkit-font-variant-ligatures:discretionary-ligatures;font-variant-ligatures:discretionary-ligatures;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}`],
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent implements OnInit, AfterViewInit {
  readonly ICON_CLASS = 'mcrai-icon';

  @Input() set color(value: string) {
    this._removeAllColorClasses();

    this._renderer
      .addClass(this._elRef.nativeElement, `${this.ICON_CLASS}--${value}`);
  }

  constructor(
    private _renderer: Renderer2,
    private _elRef: ElementRef
  ) { }

  ngOnInit() {
    this._renderer
      .addClass(this._elRef.nativeElement, this.ICON_CLASS);
  }

  ngAfterViewInit() { }

  private _removeAllColorClasses() {
    const colors = ['primary', 'secondary', 'alternative'];

    colors.forEach(color => {
      this._renderer
        .removeClass(this._elRef.nativeElement, `${this.ICON_CLASS}--${color}`);
    });
  }
}
